import UserEvents from "./UserEvents";
import Message from "./Message";
import { checkBrowser } from "./Utils"
import CONSTANTS from "./Constants";

export default class Links{

    static internalLink(event, data, spread_settings) {
        event.stopImmediatePropagation();
        Links.sendInternalLinkMessage(data, spread_settings, event.currentTarget);
    }

    static sendInternalLinkMessage(message, spread_settings, eventTarget) {
        message.message = "internal_link"

        UserEvents.sendEventUpdate('Link', 'Internal', message.issue_id + "|" + message.spread_id, spread_settings, eventTarget);
        Message.sendMessage(message, spread_settings._spread_globals.spread_id);
    }

    static externalLink(event, spread_settings) {
        event.stopImmediatePropagation();
        let target = $(event.currentTarget),
            href = target.attr("data-external-link"),
            message = {
                link: href,
                message: "external_link"
            }
            if(target.attr("data-link-target")){
                message.target = target.attr("data-link-target");
            }else{
                message.not_blank = !!target.attr("data-link-not-blank"); // !! to cast to bool
            }
        ;
        UserEvents.sendEventUpdate('Link', 'External', href, spread_settings, event.currentTarget);
        Message.sendMessage(message, spread_settings._spread_globals.spread_id);
    }

    static fileLink(event, spread_settings) {
        event.stopImmediatePropagation();
        const link = Links.fileUrl(spread_settings.data_domain, $(event.currentTarget).attr("data-file-link"));
        const message = {
            link,
            target: event.currentTarget.getAttribute('data-link-target') || '_blank',
            message: "file_link"
        };
        Message.sendMessage(message, spread_settings._spread_globals.spread_id);

        UserEvents.sendEventUpdate('Link', 'File', link, spread_settings, event.currentTarget);
    }

    /**
     * The URL a file link opens, in the form an anchor's `href` property reports it. A download is
     * tracked by that URL, hash folder included: it is the only label that is true (a hash-stripped
     * URL 404s) and it makes a group click and a text-link click of the same file report the same
     * thing. Text links already report `.href`, which percent-encodes; `new URL()` does the same
     * here. Publications published before the publisher fix carry a doubled leading slash on group
     * links; collapsing it keeps their label in line with the anchors too.
     *
     * @param {string} dataDomain
     * @param {string} path the published path, relative to the data domain
     * @returns {string}
     */
    static fileUrl(dataDomain, path) {
        const link = dataDomain + path.replace(/^\/+/, '/');
        try {
            return new URL(link).href;
        } catch (e) {
            return link;
        }
    }

    /**
     * A link into the frontend interface ("expand", "close_expand", …). The frontend answers the
     * function_link message; the editor preview has no frontend, so the spread itself does what it
     * can: expand opens the next scene, close_expand returns to the first, like the classic preview did.
     * Only the `editorPreview` option counts, not the window flag: the classic preview document keeps
     * sending the message and gets FUNCTION_EXPAND back from the editor, as before.
     *
     * @param {jQuery.Event} event
     * @param {object} spread_settings
     * @param {import('./Spread').default} [spread] the spread the link sits in; needed for the preview case
     */
    static interfaceLink(event, spread_settings, spread = null) {
        event.stopImmediatePropagation();
        let data = $(event.currentTarget).data("interface-link");

        if (spread?.options.editorPreview === true) {
            if (data === 'expand') {
                spread.sceneLink('NEXT');
            } else if (data === 'close_expand') {
                spread.sceneLink('FIRST');
            }
            return;
        }

        Links.sendInterfaceLinkMessage(data, spread_settings, event.currentTarget);
    }

    static sendInterfaceLinkMessage(data, spread_settings, eventTarget) {
        let message = {
            link: data,
            message: "function_link"
        };
        Message.sendMessage(message, spread_settings._spread_globals.spread_id);

        UserEvents.sendEventUpdate('Link', 'Interface', data, spread_settings, eventTarget);
    }

    static referenceLink(event, spread_settings) {
        event.stopImmediatePropagation();
        let reference = $(event.currentTarget).data("reference-link");
        Links.sendReferenceLinkMessage(reference, spread_settings, event.currentTarget);
    }

    static sendReferenceLinkMessage(reference, spread_settings, eventTarget) {
        let message = {
            link: reference,
            message: "reference_link"
        };
        Message.sendMessage(message, spread_settings._spread_globals.spread_id);

        UserEvents.sendEventUpdate('Link', 'Reference', reference, spread_settings, eventTarget);
    }

    static triggerElementAction(event, scene, spread_settings) {
        event.stopImmediatePropagation();
        const data = $(event.currentTarget).data("action-link")
        const label = scene.runSelector("#" + data.uuid).trigger(CONSTANTS.EVENT_ELEMENT_ACTION, {action: data.action}).data("label")

        UserEvents.sendEventUpdate('Link', 'Element-action', label + "|" + data.action, spread_settings, event.currentTarget);
    }

    static socialLink(event, top_domain, spread_settings) {
        event.stopImmediatePropagation();
        let data = $(event.currentTarget).data("social-link");
        UserEvents.sendEventUpdate('Link', 'Social-link', data.type, spread_settings, event.currentTarget);

        //if we are sharing inside an iframe we want to load the top url.
        if (window !== window.top) {
            if (top_domain) { // after the first share we can directly do it again.
                window.open(data.href + top_domain);
            } else {
                Message.sendMessage('GET_TOP_URL', spread_settings._spread_globals.spread_id);
                $(window).one('sharedomain', function () {
                    window.open(data.href + top_domain);
                });
            }

        } else {
            if(!data.href){
                switch( data.type ){
                    case 'facebook':
                        data.href = 'https://www.facebook.com/sharer/sharer.php?u=';
                        break;
                    case 'pinterest':
                        data.href = 'https://pinterest.com/pin/create/button/?url=';
                        break;
                    case 'linkedin':
                        data.href = 'https://www.linkedin.com/shareArticle?url=';
                        break;
                    case 'twitter':
                        data.href = 'https://twitter.com/intent/tweet?url=';
                        break;
                    case 'whatsapp':
                        data.href = 'whatsapp://send?text=';
                        break;
                    case 'mail':
                        data.href = 'mailto:?body=I would like to forward you the following article: ';
                        break;
                    default:
                        console.warn(`Not a correct type found: ${data.type}`);
                        return;
                }
            }
            window.open(data.href + encodeURIComponent(window.location.href));
        }
    }

    static scrollToLink(event, spread, spread_settings, interfaceOffset) {
        event.stopImmediatePropagation();
        const currentTarget = $(event.currentTarget)
        const data = currentTarget.data("scrollto-link")

        const scrollto_target = Links.scrollTo(spread, data, interfaceOffset, currentTarget[0])
        if (scrollto_target) {
            UserEvents.sendEventUpdate('Link', 'Scrollto', currentTarget.data('label') + " -> " + scrollto_target.data('label'), spread_settings, event.currentTarget);
        }

    }

    static scrollTo (spread, data, interfaceOffset, currentTarget) {
        const scrollable = spread.getScrollContainer() || spread.runSelector("#" + data.scene)
        const scrollto_target = spread.runSelector("#" + data.element)

        if(scrollto_target.length === 1){
            if (spread.embeddedWithJsControl && spread.embeddedType === CONSTANTS.EMBEDTYPES.FULLHEIGHT) {
                Message.sendEmbedMessage("SCROLL_TO", {
                    scroll: scrollto_target[0].getBoundingClientRect().top,
                    browser: checkBrowser()
                });
            } else if (scrollable.length > 0 ) {
                const scale = (spread.getSceneByUuid(data.scene)?.sizeData?.scale ?? 1);
                const new_scrolltop = spread.getScrollTop() + scrollto_target[0].getBoundingClientRect().top - spread.getScrollViewportTop() - interfaceOffset.top

                scrollable.animate({
                        scrollTop: new_scrolltop - (data.offset ?? 0) * scale
                    }, {
                        duration: data.speed,
                        complete: () => currentTarget?.blur?.()
                    }
                );
            }
            return scrollto_target
        }
    }

    static postMessageLink(event, spread_settings) {
        try{
            let message = JSON.parse(event.currentTarget.dataset.postmessageLink);
            try{
                message = JSON.parse(message);
            }catch(error){
                //no double decode possible, probably not an object
            }

            window.top.postMessage(message, '*');

            if(window.top !== window.parent){
                window.parent.postMessage(message, '*');
            }

            UserEvents.sendEventUpdate('Link', 'Postmessage', typeof message === 'string' ? message : '', spread_settings, event.currentTarget);
        }catch(e){
            console.warn("PostMessageLink failed", event, e);
        }

    }

    static trackClickedLink(event, spread_settings) {
        UserEvents.sendEventUpdate('Link', event.currentTarget.dataset.linkType === 'file' ? 'File' : 'External', event.currentTarget.href, spread_settings, event.currentTarget.children[0]);
        return true
    }
}
